function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 26.5,
  cy: 26.5,
  r: 26.5,
  fill: "#FF6A12",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.761 36.692c-1.929 0-3.492 1.485-3.492 3.316v.761h22.423v-.761c0-1.831-1.563-3.316-3.492-3.316H17.761z",
  fill: "#000098"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.308 24.462c0-5.741 4.481-10.193 10.262-10.193 2.597 0 4.817.832 6.366 1.997.838.624 1.215 1.29 1.215 2.08 0 1.04-.838 1.872-2.01 1.872-.503 0-1.047-.208-1.634-.624a6.397 6.397 0 00-3.854-1.29c-3.56 0-6.24 2.705-6.24 6.158 0 3.41 2.68 6.157 6.282 6.157 1.76 0 3.268-.624 4.399-1.623.418-.416 1.047-.749 1.675-.749 1.089 0 1.885.874 1.885 1.955 0 .5-.21 1.04-.796 1.706-1.592 1.706-4.398 2.746-7.288 2.746-5.78 0-10.262-4.493-10.262-10.192z",
  fill: "#FFF"
}));

function SvgLogoOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrange);
export default __webpack_public_path__ + "static/media/logo-orange.c5034ec0.svg";
export { ForwardRef as ReactComponent };